import './assets/main.scss'
import './assets/toast.scss'

import * as Sentry from '@sentry/vue'
import { createApp } from 'vue'

import { VueQueryPlugin } from '@tanstack/vue-query'
import Vue3Toastify, { type ToastContainerOptions } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import App from './App.vue'
import i18n from './plugins/i18n/i18n'
import router from './router'
import WarrantyApiService from './services/WarrantyApiService/WarrantyApiService'
import { pinia } from './stores'
import { useUserStore } from './stores/user.store'

const app = createApp(App)

Sentry.init({
  app,
  environment: import.meta.env.VITE_ENVIRONMENT,
  dsn: 'https://a0ae86a1acafe15f1711c7d1d1ca83c6@o4509480919629824.ingest.us.sentry.io/4509491807453184',
  sendDefaultPii: true,
  tracesSampleRate: 0.1,
  tracePropagationTargets: ['https://api-uono-prd.smartserialnumber.com'],
  normalizeDepth: 10,
  _experiments: { enableLogs: true },
  integrations: [
    Sentry.browserTracingIntegration({ router, enableInp: false }),
    Sentry.vueIntegration(),
    Sentry.replayIntegration({
      networkDetailAllowUrls: ['https://api-uono-prd.smartserialnumber.com/*'],
      maskAllText: false,
      blockAllMedia: false
    })
  ],
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0.1 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(VueQueryPlugin)
app.use(Vue3Toastify, {
  autoClose: 3000,
  dangerouslyHTMLString: true,
  clearOnUrlChange: false
} as ToastContainerOptions)

WarrantyApiService.init()

const userStore = useUserStore(pinia)
if (userStore.jwtToken) {
  WarrantyApiService.checkToken()
}

app.mount('#app')
